import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["alt", "src"]

import StayTunedImg from '@/components_new/ShopCards/images/stay_tuned.svg'
import SteamLogo from '@/components_new/ShopCards/images/steam.svg'
import NintendoLogo from '@/components_new/ShopCards/images/nintendo.svg'
import PlaystationLogo from '@/components_new/ShopCards/images/playstation.svg'
import XboxLogo from '@/components_new/ShopCards/images/xbox.svg'
import BlizzardLogo from '@/components_new/ShopCards/images/blizzard.svg'
import LegendsLogo from '@/components_new/ShopCards/images/legends.svg'
import PubgLogo from '@/components_new/ShopCards/images/pubg.svg'
import EALogo from '@/components_new/ShopCards/images/ea.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCards',
  setup(__props) {

const SHOP_CARDS = [
    {
        title: 'Steam',
        id: 'steam',
        src: SteamLogo,
    },
    {
        title: 'Nintendo',
        id: 'nintendo',
        src: NintendoLogo,
    },
    {
        title: 'Play Station',
        id: 'playstation',
        src: PlaystationLogo,
    },
    {
        title: 'Xbox',
        id: 'xbox',
        src: XboxLogo,
    },
    {
        title: 'Blizzard',
        id: 'blizzard',
        src: BlizzardLogo,
    },
    {
        title: 'EA games',
        id: 'ea',
        src: EALogo,
    },
    {
        title: 'League of Legends',
        id: 'league',
        src: LegendsLogo,
    },
    {
        title: 'PUBG mobile',
        id: 'pubg',
        src: PubgLogo,
    },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.shop_cards)
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SHOP_CARDS, (card) => {
        return _createElementVNode("li", {
          key: card.id,
          class: _normalizeClass([_ctx.$style.shop_cards__item, _ctx.$style[card.id]])
        }, [
          _createElementVNode("img", {
            src: card.src,
            alt: card.title
          }, null, 8, _hoisted_1)
        ], 2)
      }), 64))
    ], 2),
    _createElementVNode("img", {
      class: _normalizeClass(_ctx.$style.pic_stay_tuned),
      alt: _ctx.$tr('rewards.alt_stay_tuned'),
      src: _unref(StayTunedImg)
    }, null, 10, _hoisted_2)
  ]))
}
}

})